export const state = {
  
  menuList: ''
  };
  
  export const getters = {
    getMenus(state){
      return state.menuList;
    }
  };

  export const mutations = {
    setMenus(state, payload) {
      state.menuList = payload;
    },
    resetMenus(state) {
      state.menuList = "";
    }
  };
  